<nav
  class="bottom-bar is-mobile"
  [class.bottom-bar--over-search]="overSearch()"
  [class.bottom-bar--hidden]="keyboardOpen()"
  (touchmove)="onTouchMove($event)">
  <ul>
    @for (
      button of bottomBarFilterActive.bottomBarButtons();
      track button.text;
      let index = $index;
      let count = $count
    ) {
      <li
        #tabRoute="routerLinkActive"
        class="semibold"
        routerLinkActive
        [class.active]="button.active || isRouteActive(button, tabRoute.isActive)">
        <button
          mat-icon-button
          [color]="button.color"
          [class]="button.class"
          [class.active]="isRouteActive(button, tabRoute.isActive)"
          [routerLink]="button.link?.length ? (button.link | routeTranslate) : button.link"
          [queryParams]="button.queryParams"
          (click)="onActiveChange(index); button.onClick ? button.onClick() : null">
          @if (button.icon) {
            <sharry-icon [registryName]="button.icon"></sharry-icon>
          }
          @if (button.avatar) {
            <span
              [avatar]="{
                size: 'small',
                imgSize: '38px',
                user: user(),
              }"></span>
          }
        </button>
        @if (button.text) {
          {{ button.text | i18next }}
        }
      </li>
    }
  </ul>
</nav>
<sharry-search-bar-mobile class="is-mobile"></sharry-search-bar-mobile>
